#import "./AssetListFields.graphql"

query GetAssetReturns($includeCompleted: Boolean) {
  assetReturns(includeCompleted: $includeCompleted) {
    leftOn
    employee {
      id
      name
      worksAtFp
    }
    items {
      id
      expectedReturnMethod
      returnDueOn
      returnedOn
      returnMethod
      stage
      asset {
        ...AssetListFields
      }
    }
  }
}
